export const locationsData = [
  {
    id: "new-mexico",
    title: "New Mexico",
    description: "Full-service traffic control coverage across New Mexico, providing comprehensive solutions for construction, infrastructure, and special events. Our local expert teams are available 24/7 to ensure safety and compliance with state regulations while maintaining smooth traffic flow throughout the region.",
    image: "/lovable-uploads/b454b8e5-ac00-4035-9c54-52cb3e19efc1.png",
    features: [
      "24/7 Emergency Response",
      "Full Equipment Inventory",
      "State-Certified Flaggers",
      "Local Expert Team"
    ]
  },
  {
    id: "california",
    title: "California",
    description: "Comprehensive traffic management solutions across California's diverse urban and highway projects. Our experienced teams handle everything from complex city intersections to major highway operations, ensuring safety and efficiency in the nation's most populous state.",
    image: "/lovable-uploads/8b5e1a79-a916-42a5-829c-859e75065801.png",
    features: [
      "Complete Equipment Fleet",
      "Urban Project Specialists",
      "Rapid Response Team",
      "WATCH Certification"
    ]
  },
  {
    id: "colorado",
    title: "Colorado",
    description: "Specialized mountain and urban traffic control services throughout Colorado's challenging terrain. From high-altitude mountain passes to busy metropolitan areas, our teams are equipped with extensive experience in handling diverse weather conditions and complex traffic scenarios.",
    image: "/lovable-uploads/afec49b8-d530-4b3a-84d6-fd9d4fcc0427.png",
    features: [
      "Winter Operations Specialists",
      "Mountain Project Expertise",
      "Full Service Coverage",
      "CDOT Certified"
    ]
  },
  {
    id: "arizona",
    title: "Arizona",
    description: "Desert-optimized traffic control solutions with specialized equipment and expert personnel. Our teams are trained to handle extreme weather conditions while maintaining the highest safety standards across Arizona's urban centers and remote locations.",
    image: "/lovable-uploads/775c9b9e-dfb9-442a-937a-7eaee453ef88.png",
    features: [
      "Heat-Resistant Equipment",
      "Desert Operations Experts",
      "24/7 Available Team",
      "ADOT Qualified"
    ]
  },
  {
    id: "nevada",
    title: "Nevada",
    description: "Specialized traffic management services covering Nevada's unique mix of tourism hotspots and urban developments. Our teams excel in handling high-volume tourist areas and major infrastructure projects, ensuring smooth traffic flow in both urban and remote locations.",
    image: "/lovable-uploads/813d2e7d-fab0-4bb8-bf69-3fb84689e720.png",
    features: [
      "Event Management Specialists",
      "Tourism-Focused Solutions",
      "Urban Project Experts",
      "NDOT Certified"
    ]
  },
  {
    id: "texas",
    title: "Texas",
    description: "Large-scale traffic control capabilities spanning the vast state of Texas. Our comprehensive coverage includes urban centers, highways, and rural areas, with specialized teams ready to handle projects of any size while maintaining strict safety and regulatory compliance.",
    image: "/lovable-uploads/05308a21-5267-4eb8-9c24-0bd28b3d6fa4.png",
    features: [
      "Large-Scale Project Capability",
      "Emergency Response Team",
      "Statewide Coverage",
      "TxDOT Certified"
    ]
  },
  {
    id: "utah",
    title: "Utah",
    description: "Year-round traffic management solutions adapted for Utah's diverse seasonal conditions and terrain. Our experienced teams handle everything from ski resort access routes to major urban construction projects, ensuring safe and efficient traffic flow in all weather conditions.",
    image: "/lovable-uploads/ed99ae9b-d1b4-45c6-84d8-127f856166ef.png",
    features: [
      "Mountain Project Specialists",
      "Complete Equipment Fleet",
      "Year-Round Operations",
      "UDOT Qualified"
    ]
  }
];
